/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useContext } from 'react'
import { Form, Formik } from 'formik'
import { useHistory, useLocation } from 'react-router-dom'
import * as Yup from 'yup'
import { validateMessages, ROUTE_LOGIN, ROUTE_REGISTER_SUCCESS } from '../constants'
import FormInput from './input'
import TelephoneInput from './phone'
import { useTranslation, Trans } from 'react-i18next'
import _ from 'lodash'
import axios from 'axios'
import { toast } from 'react-toastify'
import Social from './social'
import moment from 'moment'
import cookie from 'react-cookies'
import 'react-phone-input-2/lib/bootstrap.css'
import PasswordStrengthBar from 'react-password-strength-bar'
import qs from 'query-string'
import TagManager from 'react-gtm-module'
import { UserContext } from '../context/UserContext'
import { phoneNumberValidation } from '../utils/phoneNumberValidation'

const RegisterForm = (props) => {
  const history = useHistory()
  const { t } = useTranslation('translation', { useSuspense: false })
  const { user, isSocial, socialType, setFields, setUser, fetchingUser, loggedUser } = useContext(UserContext)
  const [messages, setMessages] = useState({})
  const location = useLocation()
  const [from] = useState(qs.parse(location.search).from)
  const tr = qs.parse(location.search).tr

  const registerSchema = (messages, isSocial) => {
    const toReturn = {
      name: Yup.string().required(messages.required),
      surname: Yup.string().required(messages.required),
      email: Yup.string().required(messages.required),
      type: Yup.string().required(messages.required),
      phone_no: Yup.string().required(messages.required)
      .test('validPhoneNumber',messages.validPhoneNumber,(value) => phoneNumberValidation(value))
    }
    return Yup.object().shape({
      ...toReturn,
      ...isSocial ? {} : { password: Yup.string().min(8, messages.passwordMax).required(messages.required) }
    })
  }

  useEffect(() => {
    if (!fetchingUser) {
      TagManager.dataLayer({
        dataLayer: {
          visitorLoginState: 'logged-out',
          userId: loggedUser.id,
          pageTitle: 'Zappyrent | Auth',
          pageType: 'auth',
          trackCode: tr,
          userType: loggedUser.type
        }
      })
    }
  }, [tr, loggedUser, fetchingUser])

  useEffect(() => {
    _.map(validateMessages, (item) => {
      messages[item] = t(item)
    })
    setMessages(messages)
    //retrive user_type and origin form gets 
    setUser({
      ...user,
      'type': user.type ?? 'tenant',
      'name': user.name ?? '',
      'surname': user.surname ?? '',
      'email': user.email ?? '',
      'password': user.password ?? '',
      'from': from ?? '',
      'phone_no': user.phone_no ?? ''
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitUser = async (user) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'asyncAction',
        gaHitType: 'event',
        category: 'Signup',
        action: 'Signup-Submit',
        label: (isSocial) ? socialType : 'onsite'
      }
    })
    try {
      const { data: res } = await axios.post(`${process.env.REACT_APP_API_PATH}/auth/signup`, user)
      window.user = res.data
      cookie.save('8egma2jfs9mu', res.data.api_token, {
        expires: moment().add(7, 'days').toDate(),
        path: '/'
      })
      //window.location.href = `${process.env.REACT_APP_WEBSITE_PATH}/${res.data.redirect}`
      // history.replace('/register/success')
      localStorage.setItem('user', JSON.stringify(res.data));
      window.location.href = from ? `${ROUTE_REGISTER_SUCCESS}?from=${encodeURIComponent(from)}` : ROUTE_REGISTER_SUCCESS
    } catch (e) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'asyncAction',
          gaHitType: 'event',
          category: 'Signup',
          action: 'Signup-Fail',
          userId: user.id,
          userType: user.type,
          label: (isSocial) ? socialType : 'onsite'
        }
      })
      toast.error(t(e.response.data.message))
    }
  }
  return (
    <div className='p-6 w-full'>
      <>
        <span className='py-2'>
          <Trans i18nKey='alreadySignUp'>
            Already signed up? <a onClick={() => history.push((from) ? `${ROUTE_LOGIN}?from=${encodeURIComponent(from)}` : ROUTE_LOGIN)} className='text-black font-bold underline cursor-pointer'>Sign in here</a>
          </Trans>
        </span>
        <Social handleOnSuccess={setFields} />
        <Formik
          enableReinitialize={true}
          initialValues={user}
          onSubmit={async (values) => {
            setFields(values)
            submitUser({ ...values })
          }}
          validationSchema={() => registerSchema(messages, isSocial)}
        >
          {(formikProp) => {
            return (
              <Form>
                <div className="flex w-full mt-8 mb-6">
                  <input
                    id="radioTenant"
                    type="radio"
                    name="type"
                    className="hidden "
                    value="landlord"
                    checked={formikProp.values.type === "landlord"}
                    onChange={() => {
                      formikProp.setFieldValue("type", "landlord")
                    }}
                  />
                  <label htmlFor="radioTenant" className="flex items-center cursor-pointer text-gray-700 text-m font-bold w-1/2 justify-center">
                    <span className="w-6 h-6 inline-block mr-2 rounded-full border border-grey flex-no-shrink"></span>
                    {t('landlord')}
                  </label>
                  <input
                    id="radioLandlord"
                    type="radio"
                    name="type"
                    className="hidden"
                    value="tenant"
                    checked={formikProp.values.type === "tenant"}
                    onChange={() => {
                      formikProp.setFieldValue("type", "tenant")
                    }}
                  />
                  <label htmlFor="radioLandlord" className="flex items-center cursor-pointer text-gray-700 text-m font-bold w-1/2 justify-center">
                    <span className="w-6 h-6 inline-block mr-2 rounded-full border border-grey flex-no-shrink"></span>
                    {t('tenant')}
                  </label>
                </div>
                <label class="block text-gray-700 text-sm font-bold -mb-2">
                  {t('name')}
                </label>
                <FormInput
                  field={{
                    type: 'text',
                    className: 'w-full',
                    name: 'name',
                  }}
                  error={!!formikProp.errors.name && !!formikProp.touched.name}
                />
                <label class="block text-gray-700 text-sm font-bold -mb-2">
                  {t('surname')}
                </label>
                <FormInput
                  field={{
                    type: 'text',
                    className: 'w-full',
                    name: 'surname',
                  }}
                  error={!!formikProp.errors.surname && !!formikProp.touched.surname}
                />
                <label class="block text-gray-700 text-sm font-bold -mb-2">
                  {t('email')}
                </label>
                <FormInput
                  field={{
                    type: 'email',
                    className: 'w-full',
                    name: 'email',
                  }}
                  error={!!formikProp.errors.email && !!formikProp.touched.email}
                />
                <div>
                  <label class="block text-gray-700 text-sm font-bold mb-2">
                    {t('phoneNumber')}
                  </label>
                  <TelephoneInput
                    onChange={(value, data) => formikProp.setFieldValue("phone_no", value, '')
                    && formikProp.setFieldValue("dial_code", data.dialCode)}
                    error={!!formikProp.errors.phone_no && !!formikProp.touched.phone_no}
                    errorMessage={formikProp.errors.phone_no}
                  />                     
                </div>
                {!isSocial && (
                  <>
                    <label class="block text-gray-700 text-sm font-bold mt-4 -mb-2">
                      {t('password')}
                    </label>
                    <FormInput
                      field={{
                        type: 'password',
                        className: 'w-full',
                        name: 'password',
                      }}
                      error={!!formikProp.errors.password && !!formikProp.touched.password}
                    />
                  </>
                )}
                <PasswordStrengthBar password={formikProp.values.password} />
                <p className="mt-6 mb-2 text-sm text-gray-700 text-center">
                  <Trans i18nKey='acceptServiceTerms'>
                    Text <a className="underline" href={t('acceptServiceTermsLink')} rel="noopener noreferrer" target="_blank" title={t('acceptServiceTermsTitle')}>Link text</a>.
                  </Trans>
                </p>
                <button className='bg-primary px-4 p-2 w-full text-white my-2' type='submit'>{t('continue')}</button>
              </Form>
            )
          }}
        </Formik>
        <div className='flex flex-col'>
          {/* <span>
          Non sei tu? 
          <a href='/login' className='text-black underline font-bold'>Usa un altro account</a>
        </span> */}
        </div>
      </>
    </div>
  )
}

export default RegisterForm